import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { ChevronRight } from 'lucide-react';
interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface ShopBreadcrumbProps {
  items: BreadcrumbItem[];
}
export const ShopBreadcrumb: React.FC<ShopBreadcrumbProps> = ({
  items
}) => {
  const navigate = useNavigate();
  return <Breadcrumb>
      <BreadcrumbList className="pt-[5px] md:pt-0">
        {/* Home */}
        <BreadcrumbItem>
          <BreadcrumbLink onClick={() => navigate('/')} className="cursor-pointer hover:text-foreground">
            Home
          </BreadcrumbLink>
        </BreadcrumbItem>
        
        {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return <React.Fragment key={index}>
              <BreadcrumbSeparator>
                <ChevronRight className="h-4 w-4" />
              </BreadcrumbSeparator>
              
              <BreadcrumbItem>
                {isLast ? <BreadcrumbPage className="font-medium text-sm">
                    {item.label}
                  </BreadcrumbPage> : <BreadcrumbLink onClick={() => item.href && navigate(item.href)} className="cursor-pointer hover:text-foreground">
                    {item.label}
                  </BreadcrumbLink>}
              </BreadcrumbItem>
            </React.Fragment>;
      })}
      </BreadcrumbList>
    </Breadcrumb>;
};